import React from 'react';

import { WDSButton } from 'wanderu-components';

import styles from './StationDetailPopover.scss';

interface StationDetailPopoverProps {
    stationName: string;
    stationId: string;
    tripsAtStation: number;
    isFiltered: boolean;
    direction: 'depart' | 'arrive';
    onFilter: () => void;
    onClose: () => void;
}

function StationDetailPopover({
    stationName,
    stationId,
    tripsAtStation,
    isFiltered,
    direction,
    onFilter,
    onClose,
}: StationDetailPopoverProps) {
    const singular = tripsAtStation === 1;
    const tripLabel = singular
        ? 'trip'
        : 'trips';
    const directionLabel = direction === 'depart'
        ? (singular
            ? 'departs from'
            : 'depart from')
        : (singular
            ? 'arrives at'
            : 'arrive at');

    return (
        <div className={styles.popover}>
            <div className={styles.header}>
                <div className={styles.stationName}>{stationName}</div>
                <button
                    aria-label="Close"
                    className={styles.closeButton}
                    onClick={onClose}
                    type="button"
                >
                    &times;
                </button>
            </div>
            <div className={styles.tripCount}>
                {tripsAtStation} {tripLabel} {directionLabel} this stop
            </div>
            <WDSButton
                className={isFiltered
                    ? styles.removeButton
                    : styles.filterButton}
                color={isFiltered
                    ? 'neutral'
                    : 'primary'}
                onClick={onFilter}
                size="small"
                variant="contained"
                fullWidth
            >
                {isFiltered
                    ? 'Remove this filter'
                    : `Show only ${tripsAtStation} ${tripLabel} ${direction === 'depart'
                        ? 'from'
                        : 'to'} here`}
            </WDSButton>
        </div>
    );
}

export default React.memo(StationDetailPopover);
